import { number } from '@amcharts/amcharts4/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTotalCntFromDifferentTypes'
})
export class GetTotalCntFromDifferentTypesPipe implements PipeTransform {

  transform(listOfTypes: Partial<{count: number}>[]): number {
    return listOfTypes.reduce((totalCount, currentObj) => totalCount + currentObj.count , 0);
  }

}
